import { FC, PropsWithChildren } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { AssistantTitle } from './assistant-title';
import { GradientBar } from './gradient-bar';
import { HeaderBar } from './header-bar';
import { PanelControls } from './panel-controls';

interface AssistantHeaderProps {
  containerStyles?: Interpolation<Theme>;
}
interface AssistantHeaderNamespace extends FC<PropsWithChildren<AssistantHeaderProps>> {
  Title: typeof AssistantTitle;
  HeaderBar: typeof HeaderBar;
  PanelControls: typeof PanelControls;
  GradientBar: typeof GradientBar;
}

export const AssistantHeader: AssistantHeaderNamespace = ({ children, containerStyles }) => {
  return <div css={[defaultStyles.container, containerStyles]}>{children}</div>;
};

const defaultStyles = {
  container: css`
    display: grid;
  `,
};

AssistantHeader.Title = AssistantTitle;
AssistantHeader.HeaderBar = HeaderBar;
AssistantHeader.PanelControls = PanelControls;
AssistantHeader.GradientBar = GradientBar;
